// Normalizes a support booked-event into the "contact" the call surface drives: the same
// identifiers SupportContactActions consumes (patient/practitioner/clinic/event) plus the
// display name and phone. The phone click on a support card always targets the patient.

export function deriveSupportCallContact(booking) {
  if (!booking) {
    return null
  }

  const name =
    booking?.patientInfoData?.name ||
    booking?.patientName ||
    booking?.patientInfoData?.fullName ||
    'Patient'
  const rawPhone = booking?.patientInfoData?.mobile || booking?.patientMobile || ''
  const clinicBrandName =
    booking?.clinicBrandName ||
    booking?.clinicBrandData?.brandName ||
    booking?.clinicBrandData?.name ||
    booking?.clinicBrandData?.title ||
    ''

  return {
    bookedEventId: booking?.id || '',
    patientId: booking?.patientId || '',
    practitionerId: booking?.mentorId || '',
    clinicBrandId: booking?.clinicBrandId || '',
    clinicId: booking?.clinicId || '',
    clinicBrandName,
    eventType: booking?.eventType || '',
    targetRole: 'patient',
    name,
    rawPhone,
  }
}

// Digits-only form suitable for tel:/wa.me (keeps a leading +).
export function normalizeDialablePhone(rawPhone) {
  return String(rawPhone || '').replace(/[^\d+]/g, '')
}

export function hasDialablePhone(rawPhone) {
  return normalizeDialablePhone(rawPhone).replace(/^\+/, '').length >= 6
}

// Masks all but the last `visible` digits for the default (privacy-preserving) display.
export function maskPhone(rawPhone, visible = 4) {
  const normalized = normalizeDialablePhone(rawPhone)
  if (!normalized) {
    return ''
  }
  const hasPlus = normalized.startsWith('+')
  const digits = normalized.replace(/^\+/, '')
  if (digits.length <= visible) {
    return normalized
  }
  const shown = digits.slice(-visible)
  const masked = '•'.repeat(Math.max(2, digits.length - visible))
  return `${hasPlus ? '+' : ''}${masked}${shown}`
}
